import type { BlockFile } from 'shared-types';

type LocaleData = BlockFile['locales'][string];

const defaultBlockData = {};

const translatable: LocaleData['translatable'] = {};
const defaultLocaleData: LocaleData = { file: null, translatable };

const localePlaceholders = {
  file: '{{ locales.file }}' as const,
  title: '{{ locales.translatable.title }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockFileData: BlockFile = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockFile['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
